$(document).ready(function () {

    var Theme2 = (function () {

        var old_theme_js = function () {

            function setEqHeight() {
                equalheight('#we-believe .col');
                equalheight('#areas-main .item ul');
                equalheight('#areas-main .item header');
                equalminheight('#prepared-resources .item .inner');
                equalheight('#how-help .row-2 .col .item header');
                equalheight('.attorney-list .attorney');
                /*
                equalheight('#firm-home .content > div');
                equalheight('#ourfirm .col');
                */
            };

            $(function () {
                $('a[href*=#]:not([href=#]).scroller').click(function () {
                    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html,body').animate({
                                scrollTop: target.offset().top - 30
                            }, 1000);
                            return false;
                        }
                    }
                });
            });

            $(document).ready(function () {

                $('.btn-load-more-ajax a').on('click', function () {
                    var btn = $(this);
                    var contentTarget = btn.parent().data('target');
                    var appendTo = btn.parent().data('append-to');
                    var loadMore = btn.parent().data('load-more');
                    $.get(btn.attr('href'), function (data) {
                        $(appendTo).append($(data).find(contentTarget));
                        var nextBtn = $(data).find(loadMore).attr('href');
                        if (nextBtn) {
                            btn.attr('href', nextBtn);
                        } else {
                            btn.parent().hide();
                        }
                    });
                    return false;
                });

                $("#commentform").addClass("noauto");

                // ===== Scroll to Top ====
                $(window).scroll(function() {
                    let browserWidth = $(window).width();
                    if ($(this).scrollTop() >= 50 && browserWidth <= 991) { // If page is scrolled more than 50px
                        $('#return-to-top').fadeIn(100); // Fade in the arrow
                    } else {
                        $('#return-to-top').fadeOut(100); // Else fade out the arrow
                    }
                });

                /* return to top button */
                $('#return-to-top').click(function() {
                    $('body,html').animate({
                        scrollTop: 0
                    }, 500);
                });

                $(".accordion-contacts dt a").click(function (e) {

                    var image = $(this).data("image");
                    $("#map-home").css("background-image",'url(' + image + ')');                
                });

                //////////////////

                var TIMEOUT = 300;
                $('body').wrapInner('<div class="page-inner-area"/>');
                $('body > .page-inner-area').wrapInner('<div id="wrapper"/>');
                $('<span class="fader"/>').appendTo('.page-inner-area').css('opacity', 0);
                $('.but-mobile').click(function () {
                    if (!$('body').hasClass('open-menu')) {
                        $('body').addClass('open-menu');
                        $('.fader').css('display', 'block').animate({
                            opacity: 1,
                            right: '80%'
                        }, TIMEOUT);
                        $('#wrapper').animate({right: '80%'}, TIMEOUT);
                        $('.menu-main').animate({'margin-right': 0}, TIMEOUT);
                        //$('.single-post').css('display', 'none');
                    } else {
                        $('body').removeClass('open-menu');
                        $('.fader').css('display', 'none').animate({
                            opacity: 0,
                            right: 0
                        }, TIMEOUT, function () {
                            $(this).css('display', 'none');
                        });
                        $('#wrapper').animate({right: 0}, TIMEOUT);
                        $('.menu-main').animate({'margin-right': '-80%'}, TIMEOUT);
                        $('.single-post').css('display', 'block');
                    }
                    ;
                    return false;
                });

                $('.fader').click(function () {
                    $('body').removeClass('open-menu');
                    $('.fader').css('display', 'none').animate({
                        opacity: 0,
                        right: 0
                    }, TIMEOUT, function () {
                        $(this).css('display', 'none')
                    });
                    $('#wrapper').animate({right: 0}, TIMEOUT);
                    $('.menu-main').animate({'margin-right': '-80%'}, TIMEOUT);
                    $('.single-post').css('display', 'block');
                });

                $('.menu-main > ul li').has('> ul').addClass('has-drop');

                $('.menu-main .has-drop > a').each(function () {
                    $('<span class="opener visible-xs visible-sm"/>').appendTo(this);
                });

                $('.menu-main .has-drop > a').click(function () {
                    $(this).closest('li').find('> ul').slideToggle();
                    $(this).closest('li').toggleClass('open');
                    return false;
                });

                $(".side-address a.but-hours").on("click", function (e) {
                    e.preventDefault();
                    var parent = $(this).parents(".side-address");
                    var container = parent.find(".popup-hours");
                    var delta = parent.find(".address-header").innerHeight();
                    var height = container.innerHeight();
                    var position = $(this).position();
                    var top = position.top + delta;
                    container.css("top", top - height - 15);
                    container.toggleClass("visible");
                    var offsetButton = $(this).offset().left;
                    var offsetContainer = container.offset().left;
                    container.find(".popup-arrow").css("left", (offsetButton - offsetContainer + $(this).innerWidth() / 2) - 10);
                });

                $(".closebtn").on("click",function(e){
                    e.preventDefault();
                     var parent = $(this).parents(".side-address");
                    var container = parent.find(".popup-hours");
                     container.toggleClass("visible");
                     //$(".popup-hours").css('opacity', '0');
                });


                $(".footer-accordion a.but-hours").on("click", function (e) {
                    e.preventDefault();
                    var parent = $(this).parents(".footer-accordion");
                    var container = parent.find(".popup-hours");
                    var delta = parent.find(".footer-accordion").innerHeight();
                    var height = container.innerHeight();
                    var position = $(this).position();
                    var top = position.top + delta;
                    container.css("top", top - height - 15);
                    container.toggleClass("visible");
                    var offsetButton = $(this).offset().left;
                    var offsetContainer = container.offset().left;
                    container.find(".popup-arrow").css("left", (offsetButton - offsetContainer + $(this).innerWidth() / 2) - 10);
                });

                $(".closebtn").on("click",function(e){
                    e.preventDefault();
                     var parent = $(this).parents(".footer-accordion");
                    var container = parent.find(".popup-hours");
                     container.toggleClass("visible");
                     //$(".popup-hours").css('opacity', '0');
                });


                var slider_results = $("#slider-results");

                slider_results.owlCarousel({
                    items: 6,
                    itemsDesktop: [1200, 4],
                    itemsDesktopSmall: [992, 3],
                    itemsMobile: [767, 1],
                    pagination: false,
                    navigation: true
                });

                var slider_team = $("#slider-team");

                slider_team.owlCarousel({
                    items: 4,
                    itemsDesktop: [1200, 4],
                    itemsDesktopSmall: [992, 2],
                    itemsMobile: [767, 1],
                    pagination: false,
                    navigation: true
                });

                var slider_awards = $("#slider-awards");

                slider_awards.owlCarousel({
                    items: 5,
                    itemsDesktop: [1200, 4],
                    itemsDesktopSmall: [992, 3],
                    itemsMobile: [767, 1],
                    pagination: false,
                    navigation: true
                });

                var slider_verdicts = $("#slider-verdicts");

                if (slider_verdicts.length) {
                    slider_verdicts.owlCarousel({
                        singleItem: true,
                        pagination: false,
                        navigation: true,
                    });
                }

                $("#areas .areas-block .opener").click(function () {
                    e.preventDefault();
                    var container = $(this).parent().find("ul");
                    container.toggleClass("opened");
                });

                $(".btn-go-url").click(function (e) {
                    e.preventDefault();
                    var parent = $(this).parent(),
                        href = parent.find("select option:selected").val();
                    window.location = href;
                });

                $("[placeholder]").textPlaceholder();

                $('.accordion > dt > a').click(function (e) {
                    e.preventDefault();
                    var parent = $(this).parents("dt");
                    if (!parent.hasClass("accordion-opened")) {
                        $(".accordion > dt.accordion-opened").removeClass("accordion-opened");
                        parent.addClass("accordion-opened");
                        var targetId = $(this).attr("href");
                        var target = $(targetId);
                        var current = $(".accordion > dd.accordion-opened");
                        target.addClass("accordion-opened");
                        current.removeClass("accordion-opened");
                        current.slideUp(400);
                        target.slideDown(400);
                    }
                });

                if($("#video-background").length) {
                     document.getElementById('video-background').play(); 
                }

            });

            $(window).load(function () {
                setEqHeight();
            });

            $(window).resize(function () {
                setEqHeight();
            });

        };

        var faqs = function () {

            $('.qa-faqs h3 a').on('click', function (event) {
                event.preventDefault();
                $(this).stop().toggleClass('active');
                $(this).parent().toggleClass('open');

            });

        };

        var testing = function () {
            console.log('test...');
        };

        return {
            init: function () {
                old_theme_js();
                //testing();
                faqs();
            }
        }

    })();

    Theme2.init();

});